import { transition } from '@helpers/animate';
import brand, { colourWithTransparency } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Layers } from '@helpers/layers';
import { between, Device, from, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import DropdownFilterStyles from '@stories/Components/Listings/DropdownFilter/DropdownFilter.styles';
import FormStyles from '@stories/Components/Misc/Forms/Form.styles';
import SelectStyles from '@stories/Components/Misc/Forms/Inputs/Select/Select.styles';
import SearchboxStyles from '@stories/Components/Misc/Searchbox/Searchbox.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.section `
  display: flex;
  flex-wrap: wrap;

  --applyHeight: 82px;
  --itemHeight: ${fluid(40, 60)};

  > ${ButtonStyles.Container} {
    --borderRadius: 12px;
    --buttonHeight: var(--itemHeight);
    --fontSize: ${fluid(14, 18)};

    justify-content: space-between;
    grid-column: span 6;

    span[data-desktop] {
      display: none;
    }

    @media ${from(Device.DesktopSmall)} {

      grid-column: span 3;
      margin-bottom: auto;
      

      span[data-mobile] {
        display: none;
      }

      span[data-desktop] {
        display: block;
      }
    }
  }

  &[data-show-filter-btn='false'] {
    @media ${from(Device.DesktopSmall)} {
      > ${ButtonStyles.Container} {
        visibility: hidden;
        pointer-events: none;
      }
    }
  }

  @media ${from(Device.DesktopSmall)} {
    grid-template-columns: repeat(24, 1fr);
    flex-direction: column;
  }

  ${SelectStyles.Select}, ${SearchboxStyles.Form} {
    height: var(--itemHeight);
    border-color: ${brand.primary.teal.teal100};
    border-radius: 12px;
  }

  ${SelectStyles.Select}, ${SearchboxStyles.Input} {
    font-size: ${fluid(14, 18)};
  }

  ${SearchboxStyles.Button} {
    order: 1;
  }
`;
const InnerFlex = styled.div `
  flex: 1 0 100%;
  position: relative;
  z-index: 1;

  @media ${until(Device.DesktopSmall)} {
    ${transition('opacity, transform', 0.5)};
    position: fixed;
    top: 0;
    left: 0;
    width: calc(100% - 30px);
    max-width: 767px;
    height: 100dvh;
    z-index: 101;

    &[data-expanded='false'] {
      opacity: 0;
      transform: translateX(-100%);
      pointer-events: none;
    }
  }
`;
const MobileOverlay = styled.div `
  position: absolute;
  width: 60px;
  height: 100%;
  top: 0;
  right: -30px;
  background-color: ${colourWithTransparency(brand.global.black, 0.5)};
  z-index: 0;

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const FiltersWrapper = styled.div `
  ${transition('opacity, transform', 0.5)};

  display: flex;
  gap: 22px;

  @media ${until(Device.DesktopSmall)} {
    
    flex-direction: column;
    height: 100%;
    
    
    padding: 12px 8px 16px var(--sitePadding, 16px);
    background-color: ${brand.global.white};
    z-index: ${Layers.Navigation + 1};
    border-radius: 0 20px 20px 0;
    gap: 0;
  }

  @media ${from(Device.DesktopSmall)} {
    grid-column: span 18;
    gap: 16px 0;
    flex-wrap: wrap;
    position: relative;
    z-index: 2;

    ${DropdownFilterStyles.Container} {
      flex: 0 0 20%;
    }

    ${DropdownFilterStyles.Container} {      

      ${DropdownFilterStyles.Button} {
        position: relative;
        z-index: 10;
        background-color: ${brand.secondary.yellow.yellow50};

        &:before {
          content: '';
          width: 1px;
          height: 50%;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          background-color: ${brand.global.black};
        }
      }
    }
  }

  @media ${between(Device.DesktopSmall, Device.Desktop)} {
    ${DropdownFilterStyles.Container} {   
      &:first-of-type,
      &:nth-of-type(6n) {       

        ${DropdownFilterStyles.Button} {
          border-top-left-radius: 1000000px;
          border-bottom-left-radius: 1000000px;

          &:before {
            content: none;
          }
        }
      }

      &:last-of-type,
      &:nth-of-type(5n) {
        ${DropdownFilterStyles.Button} {
          border-top-right-radius: 100000000px;
          border-bottom-right-radius: 100000000px;
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(5) {
        z-index: 4;
      }

      &:nth-of-type(6),
      &:nth-of-type(7),
      &:nth-of-type(8),
      &:nth-of-type(9),
      &:nth-of-type(10) {
        z-index: 3;
      }

      &:nth-of-type(11),
      &:nth-of-type(12),
      &:nth-of-type(13),
      &:nth-of-type(14),
      &:nth-of-type(15) {
        z-index: 2;
      }

      &:nth-of-type(16),
      &:nth-of-type(17),
      &:nth-of-type(18) {
        z-index: 1;
      }
    }
  }

  @media ${from(Device.Desktop)} {

    ${DropdownFilterStyles.Container} {
      flex: 0 0 16.6%;
    }

    ${DropdownFilterStyles.Container} {
      &:first-of-type,
      &:nth-of-type(7n) {       

        ${DropdownFilterStyles.Button} {
          border-top-left-radius: 1000000px;
          border-bottom-left-radius: 1000000px;

          &:before {
            content: none;
          }
        }
      }

      &:last-of-type,
      &:nth-of-type(6n) {
        ${DropdownFilterStyles.Button} {
          border-top-right-radius: 100000000px;
          border-bottom-right-radius: 100000000px;
        }
      }

      &:nth-of-type(7n) {
        &:last-of-type {
          ${DropdownFilterStyles.Button} {
            border-radius: 100000000px;
          }
        }
      }

      &:nth-of-type(1),
      &:nth-of-type(2),
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(5),
      &:nth-of-type(6) {
        z-index: 4;
      }

      &:nth-of-type(7),
      &:nth-of-type(8),
      &:nth-of-type(9),
      &:nth-of-type(10),
      &:nth-of-type(11),
      &:nth-of-type(12) {
        z-index: 3;
      }

      &:nth-of-type(13),
      &:nth-of-type(14),
      &:nth-of-type(15),
      &:nth-of-type(16),
      &:nth-of-type(17),
      &:nth-of-type(18) {
        z-index: 2;
      }
    }
  }
`;
const FilterArea = styled.div `
  display: flex;
  flex-wrap: wrap;
  row-gap: 22px;
  width: 100%;

  @media ${until(Device.DesktopSmall)} {
    ${scrollbars};
    flex-direction: column;
    row-gap: 0;
    overflow: auto;
    flex-wrap: nowrap;
    padding-right: 8px;
    padding-bottom: 16px;
  }
`;
const ButtonContainer = styled.div `
  align-self: center;

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
const ShowMoreButton = styled.button `
  ${ButtonReset};
  ${transition('border')};

  margin-left: 24px;
  border-bottom: 2px solid ${brand.accent.darkBlue.darkBlue100};
  
  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  &:focus-visible,
  &:hover {
    border-bottom-color: ${brand.secondary.yellow.yellow100};
  }

  span {
    ${fonts.gotham.bold};
    color: ${brand.global.black};
    font-size: ${fluid(14, 16)};
    line-height: ${fluid(24, 26)};
  }
`;
const BaseFilterArea = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 10px;
  width: 100%;

  @media ${from(Device.DesktopSmall)} {
    margin-top: 80px;
    width: auto;
  }
`;
const ResultAmountArea = styled.div `
  ${fonts.gotham.regular};
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  flex: 1 0 auto;

  @media ${until(Device.DesktopSmall)} {
    order: 2;
    flex: 1 0 100%;
    text-align: center;
  }

  span {
    ${fonts.gotham.bold};
  }
`;
const BaseFilterRightArea = styled.div `
  flex: 1 0 auto;

  @media ${until(Device.DesktopSmall)} {
    display: flex;
    align-items: center;
    justify-content: center;
    order: 1;
    flex: 1 0 100%;
    margin-bottom: 24px;
  }
`;
const FilterOpenBtn = styled.button `
  ${ButtonReset};
  ${transition('background-color')};
  display: none;

  @media ${until(Device.DesktopSmall)} {
    ${fonts.gotham.medium};
    font-size: 16px;
    line-height: 23px;
    width: 50%;
    max-width: 177px;
    padding: 10px 16px 9px 24px;
    height: 47px;
    border: none;
    background-color: ${brand.secondary.yellow.yellow50};
    border-radius: 100000px 0 0 100000px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    position: relative;

    &:before {
      content: '';
      width: 1px;
      height: 50%;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      background-color: ${brand.global.black};
    }
  }

  &:hover {
    background-color: ${brand.secondary.yellow.yellow100};
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  svg {
    width: 23px;
  }
`;
const SortByArea = styled.div `
  grid-column: span 6;
  position: relative;


  @media ${from(Device.DesktopSmall)} {
    flex: 1 0 auto;
    margin-bottom: auto;    
    display: flex;
    align-items: center;
    gap: 8px;
  }

  ${FormStyles.Field} {

    @media ${from(Device.DesktopSmall)} {
      margin-bottom: auto;
      flex: 0 0 216px;
    }
  }

  ${SelectStyles.Wrapper} {
    &:after {
      top: calc(50% - 4px);
      right: 0;
      background-color: transparent;

      @media ${until(Device.DesktopSmall)} {
        top: 50%;
        right: 24px;
      }
    }
  }

  ${SelectStyles.Select} {
    ${fonts.gotham.bold};
    border: none;
    border-radius: 0;
    border-bottom: 2px solid ${brand.accent.darkBlue.darkBlue100};
    padding: 0;
    height: 32px;

    @media ${until(Device.DesktopSmall)} {
      ${transition('background-color')};
      ${fonts.gotham.medium};
      font-size: 16px;
      line-height: 23px;
      width: 177px;
      padding: 10px 40px 9px 16px;
      height: 47px;
      border: none;
      background-color: ${brand.secondary.yellow.yellow50};
      border-radius: 0 100000px 100000px 0;

      &:hover {
        background-color: ${brand.secondary.yellow.yellow100};
      }
    }
  }
`;
const SortByAreaLabel = styled.label `
  ${fonts.gotham.regular};
  font-size: ${fluid(14, 16)};
  line-height: ${fluid(18, 20)};
  flex: 1 0 auto;
  text-align: right;

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
const ExtraWrapper = styled(m.div) `
  flex: 0 0 100%;
  display: flex;
  gap: 16px var(--gutterWidth);
  flex-wrap: wrap;

  @media ${until(Device.DesktopSmall)} {
    display: contents;

    ${SearchboxStyles.Container} {
      order: -1;
    }
  }
`;
const SelectedWrapper = styled.div `
  flex: 0 0 100%;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 24px;

  @media ${until(Device.DesktopSmall)} {
    display: none;
  }
`;
const SelectedWrapperMobile = styled.div `
  

  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const SelectedWrapperMobileInner = styled.div `
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  margin-top: 4px;
  padding-bottom: 12px;
  
  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const Top = styled.div `
  ${fonts.gotham.regular};

  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  color: ${brand.global.black};
  padding-bottom: 14px;
  order: -1;

  > svg {
    display: block;
    width: 31px;
  }


  @media ${from(Device.DesktopSmall)} {
    display: none;
  }
`;
const TopTitle = styled.span `
  ${fonts.gotham.black};
  font-size: 20px;
  line-height: 30px;
`;
const CloseBtn = styled.button `
  ${ButtonReset};
  ${transition('background-color')};
  width: 36px;
  height: 36px;
  border-radius: 100000px;

  &:hover,
  &:focus-visible {
    background-color: ${brand.accent.darkBlue.darkBlue100};

    svg {
      color: ${brand.global.white};
    }
  }

  svg {
    ${transition('color')};
    color: ${brand.accent.darkBlue.darkBlue100};
  }
`;
const SelectedOption = styled(m.button) `
  ${ButtonReset};
  ${transition('background-color, border')};
  ${fonts.gotham.regular};

  background-color: ${brand.secondary.yellow.yellow25};
  font-size: 16px;
  line-height: 23px;
  display: flex;
  gap: 8px;
  align-items: center;
  border-radius: 40px;
  color: ${brand.global.black};
  padding: 8px 16px 8px 24px;

  svg {
    width: 20px;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
  }

  &:focus-visible,
  &:hover {
    background-color: ${brand.secondary.yellow.yellow50};
  }

  &[data-all] {
    ${fonts.gotham.bold};
    font-size: 16px;
    line-height: 26px;
    background-color: transparent;
    border-bottom: 2px solid ${brand.accent.darkBlue.darkBlue100};
    border-radius: 0;
    padding: 0;
    margin-left: 8px;
    

    &:focus-visible,
    &:hover {
      border-bottom-color: ${brand.secondary.yellow.yellow100};
    }
  }

  ${SelectedWrapperMobile} & {
    ${fonts.gotham.medium};
    font-size: 14px;
    line-height: 16px;
    padding: 6px 8px 4px 16px;
    border-radius: 1200px;
    background-color: ${brand.secondary.yellow.yellow25};
    color: ${brand.global.black};
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 0;

    &:focus-visible {
      outline: auto;
      outline-offset: 3px;
      outline-width: 2px;
    }

    &:focus-visible,
    &:hover {
      background-color: ${brand.secondary.yellow.yellow100};
    }

    &[data-all] {
      ${fonts.gotham.bold};
      font-size: 14px;
      line-height: 24px;
      background-color: transparent;
      border-bottom: 2px solid ${brand.accent.darkBlue.darkBlue100};
      border-radius: 0;
      padding: 0;
      margin-left: 0;

      &:focus-visible,
      &:hover {
        border-bottom-color: ${brand.secondary.yellow.yellow100};
      }
    }
  }
`;
const SelectedClearAll = styled.div `
  align-self: center;

  ${SelectedWrapperMobile} & {
    flex: 1 0 100%;
    padding: 8px 8px 0;
  }
`;
const FiltersStyles = {
    BaseFilterArea,
    BaseFilterRightArea,
    ButtonContainer,
    CloseBtn,
    Container,
    FilterArea,
    FilterOpenBtn,
    FiltersWrapper,
    InnerFlex,
    Top,
    TopTitle,
    ExtraWrapper,
    MobileOverlay,
    ResultAmountArea,
    SelectedClearAll,
    SelectedWrapper,
    SelectedWrapperMobile,
    SelectedWrapperMobileInner,
    SelectedOption,
    ShowMoreButton,
    SortByArea,
    SortByAreaLabel,
};
export default FiltersStyles;
